import type { AppointmentType } from "./types"

/**
 * Resolves an appointment-type code to its display label.
 *
 * English-only literal strings, like the rest of this package — see the README's note. The codes stay
 * codes rather than becoming display strings at the source, because the API should not be in the
 * business of deciding presentation.
 *
 * Dispatched with a `switch` rather than a `Record` lookup for two reasons: the compiler rejects a new
 * `AppointmentType` added without a label here, and the value comes off the
 * `telemedicine.getAppointments` response, which makes a computed member access a CodeQL finding
 * (`js/unvalidated-dynamic-method-call`).
 */
export function getAppointmentTypeLabel(appointmentType: AppointmentType): string {
  switch (appointmentType) {
    case "initialConsult":
      return "Initial consult"
    case "followUpConsult":
      return "Follow-up consult"
    default: {
      const unhandled: never = appointmentType
      throw new Error(`Unhandled appointment type: ${String(unhandled)}`)
    }
  }
}
